import { TransformComponent, TransformWrapper } from '@pronestor/react-zoom-pan-pinch'
import { SkaldElement, SkaldValue, useSkaldElements } from '@skaldaura/devkit'
import TxtWithBckContainer from 'components/blocTxt/txtWithBckContainer'
import Modal from 'components/modal/modal'
import { PExt } from 'components/myTags/myTags'
import SubgroupPopup from 'components/popupDocuments/subelementPopup'
import AnchorButtonContext from 'contexts/anchorButton'
import { useCounterContext } from 'contexts/counter'
import headbandContext from 'contexts/headband'
import { useContext, useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { getItem } from 'store/localeStorage'
import { Colors } from 'styles/colors'
import './projets.scss'

export interface IPDF {
   pages: SkaldValue[]
}

export default function ProjetsVisiteur() {
   const { setHeadband } = useContext(headbandContext)
   const { setCounter, counterDefault } = useCounterContext()
   const [isOpen, setIsOpen] = useState(false)
   const [projetsElements] = useSkaldElements(`${getItem('totem')} : Projet`)
   const [stepElement] = useSkaldElements(`${getItem('totem')} : PDF`)
   const [pdfs, setPdfs] = useState<IPDF[]>([])
   const [selectedPdf, setSelectedPdf] = useState<IPDF>(pdfs[0])
   const { setAnchorButton } = useContext(AnchorButtonContext)
   const ref = useRef<HTMLImageElement>(null)

   useEffect(() => {
      if (stepElement.length > 0) {
         stepElement[0].getPopulatedSubgroups().then((pdfs: IPDF[]) => setPdfs([...pdfs]))
      }
   }, [stepElement])

   useEffect(() => {
      setCounter(counterDefault)
      setHeadband('BE LEAN +')
      setAnchorButton([])
   }, [])

   const handleOpen = (subgroup: IPDF) => {
      setSelectedPdf(subgroup)
      setIsOpen(true)
   }
   return (
      <>
         <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
            <SubgroupPopup pdf={selectedPdf} />
         </Modal>
         <div id='mainContent' className='flex column around w100'>
            <div id='archiveBtn'>
               <Link to='archives'>
                  <TxtWithBckContainer bckClr={Colors.gris1} width='180px' height='60px'>
                     <div className='w100 h100 flex center' onClick={() => close()}>
                        <PExt color='white' fontSize='20px'>
                           Nos Succès
                        </PExt>
                     </div>
                  </TxtWithBckContainer>
               </Link>
            </div>
            <p className='flex flexStart w90 my-7'>&#x26AB; PROJETS CI EN COURS</p>
            <div id='plans' className={`projetsLength${projetsElements.length}`}>
               {projetsElements.map((element: SkaldElement) => (
                  <TransformWrapper initialScale={1} key={element.value}>
                     <TransformComponent>
                        <img src={element.value} alt='' ref={ref} />
                     </TransformComponent>
                  </TransformWrapper>
               ))}
            </div>

            <div id='projetCarousel'>
               {/* <ProjetCarousel items={items} /> */}
               <div className='imgCarousel'>
                  {stepElement.length > 0 &&
                     pdfs.map((pdf: IPDF, index) => {
                        return (
                           <img
                              key={index}
                              src={pdf.pages[0] && pdf.pages[0].value}
                              onClick={() => handleOpen(pdf)}
                           />
                        )
                     })}
               </div>
            </div>
         </div>
      </>
      // </div>
   )
}
